import { validateElement } from '../state-validator';
import {
  INSERT_ELEMENT_INTO_COLUMN,
  REMOVE_ELEMENT_FROM_COLUMN,
  SET_DROP_PREVIEW_INDEX_PATH,
  RESET_DROP_PREVIEW_INDEX_PATH,
  REINDEX_ELEMENTS,
  SET_COLUMN_BACKGROUND_COLOR,
  SET_COLUMN_PADDING
} from './action-names';

export function insertElementIntoColumn(data) {
  return {
    type: INSERT_ELEMENT_INTO_COLUMN,
    ...data,
    element: validateElement(data.element)
  };
};

export function removeElementFromColumn(data) {
  return {
    type: REMOVE_ELEMENT_FROM_COLUMN,
    ...data
  };
};

export function setDropPreviewIndexPath(data) {
  return {
    type: SET_DROP_PREVIEW_INDEX_PATH,
    ...data
  };
};

export function resetDropPreviewIndexPath(data) {
  return {
    type: RESET_DROP_PREVIEW_INDEX_PATH,
    ...data
  };
};

export function reindexElements(data) {
  return {
    type: REINDEX_ELEMENTS,
    ...data
  };
};

export function setColumnBackgroundColor(data) {
  return {
    type: SET_COLUMN_BACKGROUND_COLOR,
    ...data
  };
};

export function setColumnPadding(data) {
  return {
    type: SET_COLUMN_PADDING,
    ...data
  };
};



// WEBPACK FOOTER //
// ./app/header-builder/actions/column-actions.js